"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
var _index2 = require("../../../swcp-base/js/helpers/index");
var _axios = _interopRequireDefault(require("axios"));
var _ = require(".");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const vishowContentFileActions = new _index.ActionHelper({
  singular: "vishowcontentfile"
});
const languageActions = new _index.JoinActionHelper("contentfile", "language");
const productActions = new _index.JoinActionHelper("product", "vishowcontentfile");
const showroomActions = new _index.JoinActionHelper("showroom", "vishowcontentfile");
const pictureActions = new _index.ActionHelper({
  singular: "contentfileimage"
});
class Actions extends _index.ActionHelper {
  constructor() {
    super({
      singular: "vishowcontentfile"
    });
    _defineProperty(this, "addLanguage", body => languageActions.create(body, {
      expand: "Language"
    }, this));
    _defineProperty(this, "dropLanguage", languageActions.destroy);
    _defineProperty(this, "addProduct", body => productActions.create(body, {
      expand: "Product"
    }, this));
    _defineProperty(this, "dropProduct", productActions.destroy);
    _defineProperty(this, "addShowroom", body => showroomActions.create(body, {
      expand: "Showroom"
    }, this));
    _defineProperty(this, "dropShowroom", showroomActions.destroy);
    _defineProperty(this, "get", (id, params, module) => vishowContentFileActions.get(id, params, this));
    _defineProperty(this, "getAll", (params, module) => vishowContentFileActions.getAll(params, this));
    _defineProperty(this, "addPicture", (id, params) => pictureActions.create(id, params, this));
    _defineProperty(this, "updatePicture", pictureActions.update);
    _defineProperty(this, "dropPicture", pictureActions.destroy);
    _defineProperty(this, "init", data => {
      if (data && data.schema && data.schema.ContentFileImage && data.schema.ContentFileImage.visible === false) {
        this.state.areContentFileImagesShown = false;
      }
      return dispatch => {
        dispatch({
          type: "INIT_VISHOWCONTENTFILES",
          data: data
        });
      };
    });
    /* If the images are visible, the "ContentFileImage" expand is added to the request */
    _defineProperty(this, "preGet", (request, id, params) => {
      if (this.state.areContentFileImagesShown === true) {
        params.expand += ",ContentFileImage";
      }
      request.url = `${this._uri}/${id}${(0, _index2.paramsToString)(params)}`;
      return request;
    });
    /* We don't want to show bundle files in the list, so we filter them out */
    _defineProperty(this, "preGetAll", (request, params) => {
      if (params.filter) params.filter += " and ";
      let showroomAssetBundle = 7; // 'showroomAssetBundle' is element 7 of the 'Type' property in the schema
      let sharedAssetBundle = 8; // 'sharedAssetBundle' is element 8 of the 'Type' property in the schema
      let catalogBundle = 9; // 'catalogBundle' is element 9 of the 'Type' property in the schema

      params.filter += `Type != ${showroomAssetBundle} and Type != ${sharedAssetBundle} and Type != ${catalogBundle}`;
      request.url = `${this._uri}${(0, _index2.paramsToString)(params)}`;
      return Promise.resolve(request);
    });
    /* We check which content files have a ContentFileImageId and request the images one by one */
    _defineProperty(this, "postGetAll", (response, dispatch, useAuthentication, cancelToken = undefined) => {
      if (this.state.areContentFileImagesShown === false) {
        return null;
      }
      response.data.reduce((promise, contentfile) => {
        if (!contentfile.ContentFileImageId) {
          return Promise.resolve();
        }
        dispatch({
          type: "GET_IMAGE_REQUEST"
        });
        return promise.then(() => {
          return (0, _index2.createRequest)(useAuthentication, cancelToken).then(request => {
            request.method = "get";
            request.url = `contentfileimages?filter=ContentFileId="${contentfile.Id}"`;
            request.cancelToken = cancelToken.token;
            return (0, _index2.sendRequest)(request, useAuthentication).then(response => {
              if (response.data.length > 0) {
                let dataSent = response.data[0];
                dispatch({
                  type: "GET_IMAGE_SUCCESS",
                  data: dataSent
                });
                return response;
              }
            }).catch(error => {
              if (_axios.default.isCancel(error)) {
                //console.log('Request canceled');

                return response;
              } else {
                console.dir(error);
                dispatch({
                  type: "GET_IMAGE_FAILURE",
                  data: error.response ? error.response.data : {
                    Message: "An error occurred."
                  }
                });
                return response;
              }
            });
          });
        });
      }, Promise.resolve());
    });
    _defineProperty(this, "getSchema", () => {
      return _.config;
    });
    this.state = {
      areContentFileImagesShown: true
    };
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;